import React, { useState, useEffect, useRef, useTransition } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import AdjustWhModal from "../../../components/Modal/AdjustWhModal";

// Utils
import {
  getDataWithComp,
  getAlert,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";

import { formatDateAndTime } from "../../../../utils/DateUtils";
import { submitItems } from "../../../../utils/services";
import ProductModal from "../../../components/Modal/productmodal";

import {
  ExportInventories,
  ExportInventoriesWarehouse,
} from "../../../../utils/ExportUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import ItemModal from "../../../components/Modal/ItemModal";

import { Button, Spin } from "antd";

const sanitizeNumeric = (raw) => {
  let s = (raw ?? "").toString().replace(/[^0-9.,]/g, "");
  const i = s.indexOf(".");
  if (i !== -1) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, "");
  return s;
};

const parserStrict = (v) => sanitizeNumeric(v).replace(/,/g, "");

const formatterWithCommas = (v) => {
  if (v === null || v === undefined || v === "") return "";
  const num = Number(v);
  if (isNaN(num)) return "";
  const s = String(num);
  const [int = "", dec] = s.split(".");
  const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return dec !== undefined ? `${intFmt}.${dec}` : intFmt;
};

function Form({ name }) {
  const [isPending, startTransition] = useTransition();
  const searchDebounceRef = useRef(null);
  const [activeTab, setActiveTab] = useState(2);
  const [formItemList, setFormItemList] = useState([]);
  const [showInitialStockModal, setShowInitialStockModal] = useState(false);
  const [selectedItemForInitial, setSelectedItemForInitial] = useState(null);
  const [allItemsCache, setAllItemsCache] = useState([]);
  // console.debug("formItemList:", formItemList);
  const shouldSelectFirstRowRef = useRef(true);
  const currentItemIdRef = useRef(null);
  const isManualSelectionRef = useRef(false);
  const [isFormItemHistoryLoaded, setIsFormItemHistoryLoaded] = useState(false);

  const [formItemList2, setFormItemList2] = useState([]);
  const [formItemOnHand, setFormItemOnHand] = useState([]);
  const [formItemHistory, setFormItemHistory] = useState([]);
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  //  เก็บข้อมูลทั้งหมดไว้สำหรับ filter
  const [allItemOnHandData, setAllItemOnHandData] = useState([]);
  const [allItemHistoryData, setAllItemHistoryData] = useState([]);

  const [formItemOnHandCaseTab, setFormItemOnHandCaseTab] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // State สำหรับ Edit Modal
  const [editModalState, setEditModalState] = useState({
    open: false,
    mode: "edit",
    data: null,
  });

  // State สำหรับ force table re-render
  const [tableRefreshKey, setTableRefreshKey] = useState(0);

  const [searchItemOnHandCaseTab, setSearchItemOnHandCaseTab] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isBooting, setIsBooting] = useState(true);
  const [initialQuantity, setInitialQuantity] = useState("");
  const allItemsScrollRef = useRef(null);
  const savedScrollTopRef = useRef(0);
  const restoringScrollRef = useRef(false);

  // ข้อมูลตั้งต้น
  const [itemId, setItemId] = useState(null);
  const warehouse_Id = localStorage.getItem("WHID");
  const Emp_Position = localStorage.getItem("EmpPosition");
  const [warehouseId, setWarehouseId] = useState(
    warehouse_Id ? parseCurrency(warehouse_Id, 10) : null
  );

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const [filterOption, setFilterOption] = useState("3");
  const [showInactiveItems, setShowInactiveItems] = useState(false);

  // Modal
  const [showWhModal, setShowWhModal] = useState(false);
  const handleWhShow = () => setShowWhModal(true);
  const [showItemModal, setShowItemModal] = useState(false);
  const latestSearchRef = useRef(0);
  const rowRefs = useRef([]);
  const itemWH = localStorage?.getItem("stc-item-wh");

  const debounceRef = useRef(null);
  const itemIdRef = useRef(null);
  const skipNextSelectEffectRef = useRef(false);
  const skipFilterRef = useRef(false); // ป้องกัน useEffect filter ขณะแก้ไข

  const handleWhClose = async () => {
    setShowWhModal(false);

    currentItemIdRef.current = itemId;
    shouldSelectFirstRowRef.current = false;

    savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;

    await initializeWHOnly(true);
    await handleItemSearchFromDB(searchItemTerm, filterOption, true);

    if (itemId && warehouseId) {
      await onRowSelectOnHand(itemId, warehouseId);
    }
  };

  const onlyNumberKeyDown = (e) => {
    const { key, ctrlKey, metaKey } = e;
    if (ctrlKey || metaKey) return;

    const allowNav = new Set([
      "Backspace",
      "Delete",
      "Tab",
      "Enter",
      "Escape",
      "Home",
      "End",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ]);
    if (allowNav.has(key)) return;

    if (/[0-9]/.test(key)) return;
    if (key === ",") return;
    if (key === ".") {
      const el = e.currentTarget;
      const v = el?.value ?? "";
      const hasDot = v.includes(".");
      if (!hasDot) return;
      const dotIdx = v.indexOf(".");
      const { selectionStart, selectionEnd } = el;
      const coversDot =
        typeof selectionStart === "number" &&
        typeof selectionEnd === "number" &&
        selectionStart <= dotIdx &&
        dotIdx < selectionEnd;
      if (!coversDot) e.preventDefault();
      return;
    }
    e.preventDefault();
  };

  const selectOnFocus = (e) => {
    setTimeout(() => e?.target?.select?.(), 0);
  };

  const handleInitialStockShow = (item, index) => {
    isManualSelectionRef.current = true;
    setSelectedIndex(index);
    setSelectedItemForInitial(item);
    setInitialQuantity("");
    setShowInitialStockModal(true);
  };

  const handleInitialStockClose = () => {
    setShowInitialStockModal(false);
    setSelectedItemForInitial(null);
  };

  const handleInitialStockSubmit = async ({
    itemId,
    itemCode,
    itemName,
    warehouseId: whId,
    quantity,
  }) => {
    try {
      setIsLoading(true);

      if (!whId) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกคลัง");
      }

      await manageWhItemData(
        itemId,
        itemCode,
        itemName,
        whId,
        "BG",
        quantity,
        null,
        "เริ่มต้นคลัง",
        "เริ่มต้นคลัง",
        null
      );

      //  จำตำแหน่งสกอลล์ก่อนรีเฟรช (สำคัญ)
      savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;

      // รีเฟรชข้อมูล (ให้คงแถวเดิม)
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
      await initializeWHOnly(true);

      if (itemId && whId) {
        await onRowSelectOnHand(itemId, whId);
      }

      getAlert("OK", "ตั้งต้นสินค้าสำเร็จ");
      handleInitialStockClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    } finally {
      setIsLoading(false);
    }
  };

  const hasInitialStockInWarehouse = (itemId, warehouseId) => {
    if (!warehouseId || !allItemOnHandData.length) return false;

    const itemInWarehouse = allItemOnHandData.find(
      (item) => item.Item_Id === itemId && item.WH_Id === parseInt(warehouseId)
    );

    // ถ้ามี Last_STC_Date หรือมียอดคงเหลือ แสดงว่าเคยตั้งต้นแล้ว
    return !!itemInWarehouse && itemInWarehouse.Last_STC_Date;
  };

  const handleADJClose = async () => {
    setShowWhModal(false);
  };

  // ปรับ initializeWHOnly
  const initializeWHOnly = async (preserveSelection = true) => {
    //  ถ้า preserveSelection = true → ห้ามเลือกแถวแรก
    if (preserveSelection) {
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
    }

    const statusFilter = showInactiveItems ? "" : "AND ISNULL(is_Active, Item_Status) = 'Y'";
    const itemList = await getDataWithComp(
      "View_Set_Item",
      `${statusFilter}  ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line`
    );

    const whList = await getDataWithComp(
      "Tb_Set_WH",
      `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
    );

    setAllItemsCache(itemList || []);

    if (whList && whList.length > 0) {
      setWhDataList(whList);
    }

    return itemList || [];
  };

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      await loadLocalStorageData();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const filterDataByWarehouse = (whId) => {
    if (!whId) return;

    console.debug("🔍 Filtering by warehouse:", whId, "itemId:", itemId);

    if (itemId && allItemHistoryData.length > 0) {
      const filteredHistory = allItemHistoryData.filter(
        (item) => item.WH_Id === parseInt(whId) && item.Item_Id === itemId
      );
      console.debug(" Filtered history:", filteredHistory.length);
      setFormItemHistory(filteredHistory);
    } else {
      setFormItemHistory([]);
    }

    if (allItemOnHandData.length > 0) {
      const filteredOnHand = allItemOnHandData.filter(
        (item) => item.WH_Id === parseInt(whId)
      );
      console.debug(" Filtered on-hand:", filteredOnHand.length);
      setFormItemOnHandCaseTab(filteredOnHand);
    } else {
      setFormItemOnHandCaseTab([]);
    }

    //  ไม่ต้อง reset selectedIndex เพราะ formItemList ไม่เปลี่ยน
  };

  const onChangeWarehouse = (id) => {
    console.debug("onChangeWarehouse", id);
    const parsedId = parseCurrency(id, 10);

    //  เพิ่มบรรทัดนี้ - ป้องกันไม่ให้เลือกแถวแรก
    shouldSelectFirstRowRef.current = false;
    currentItemIdRef.current = itemId;

    setWarehouseId(parsedId);

    if (itemId && parsedId) {
      filterDataByWarehouse(parsedId);
    }
  };

  const loadLocalStorageData = async () => {
    const itemSearch = localStorage.getItem("stc-item-search") || "";
    const itemOption = localStorage.getItem("stc-item-option") || "3";

    const itemId = localStorage.getItem("stc-item-id");
    const activeTab = localStorage.getItem("stc-active-tab");
    const selectedWarehouse = localStorage.getItem("stc-select-warehouse");
    const year = localStorage.getItem("stc-year");
    const month = localStorage.getItem("stc-month");

    setSearchItemTerm(itemSearch);
    setFilterOption(itemOption);

    await handleItemSearchFromDB(itemSearch, itemOption, true);

    if (itemId && itemWH) {
      const parsedItemId = parseCurrency(itemId, 10);
      const parsedItemWH = parseCurrency(itemWH, 10);
      setItemId(parsedItemId);
      await onRowSelectOnHand(parsedItemId, parsedItemWH);
    }

    if (activeTab) setActiveTab(parseCurrency(activeTab, 10));
    if (selectedWarehouse) setWarehouseId(parseCurrency(selectedWarehouse, 10));
    if (year) setYear(year);
    if (month) setMonth(month);
    if (year || month)
      await handleHistorySearch(year, month, itemId, selectedWarehouse);
  };

  const onRowSelectOnHand = async (itemId, whId) => {
    try {
      // setItemId(itemId);

      //  Clear ข้อมูลเก่าทันที
      setFormItemOnHand([]);
      setFormItemHistory([]);
      setFormItemOnHandCaseTab([]);

      // ดึงข้อมูลสินค้าคงเหลือของ item นี้ (ทุกคลัง)
      const itemOnHand = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND Item_Id = ${itemId} ORDER BY WH_Name ASC`
      );

      if (itemOnHand && itemOnHand.length > 0) {
        setFormItemOnHand(itemOnHand);
      }

      //  ดึงข้อมูลประวัติทั้งหมด
      const allHistory = await getDataWithComp(
        "API_1201_WH_ITEM_STC",
        `AND Item_Id = ${itemId} ORDER BY STC_SEQ DESC`
      );
      setAllItemHistoryData(allHistory || []);

      // Filter Item_Status & Sort Order: ดึง ID ตามลำดับการเรียงของตารางหลัก
      const statusFilter = showInactiveItems ? "" : "AND ISNULL(is_Active, Item_Status) = 'Y'";
      const allowedItems = await getDataWithComp(
        "View_Set_Item",
        `${statusFilter} ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line`,
        null,
        "Item_Id"
      );
      
      const allowedItemIds = new Set((allowedItems || []).map((i) => i.Item_Id));
      
      // สร้าง Map สำหรับเก็บลำดับการเรียง
      const itemOrderMap = new Map();
      (allowedItems || []).forEach((item, index) => {
        itemOrderMap.set(item.Item_Id, index);
      });

      //  ดึงข้อมูลสินค้าคงคลังทั้งหมด (Original Query)
      const allOnHand = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `ORDER BY Item_Code ASC`
      );
      
      // Filter & Sort in JS
      const filteredOnHandAll = (allOnHand || [])
        .filter((item) => allowedItemIds.has(item.Item_Id))
        .sort((a, b) => {
          const orderA = itemOrderMap.get(a.Item_Id) ?? 999999;
          const orderB = itemOrderMap.get(b.Item_Id) ?? 999999;
          
          if (orderA !== orderB) return orderA - orderB;
          
          // ถ้า Item เดียวกัน ให้เรียงตามชื่อคลัง
          return (a.WH_Name || "").localeCompare(b.WH_Name || "");
        });

      setAllItemOnHandData(filteredOnHandAll || []);

      //  Filter ทันทีหลังดึงข้อมูลเสร็จ
      if (whId) {
        // Filter Tab 2: ประวัติสินค้า
        const filteredHistory = (allHistory || []).filter(
          (item) => item.WH_Id === parseInt(whId) && item.Item_Id === itemId
        );
        console.debug(" Setting formItemHistory:", filteredHistory.length);
        setFormItemHistory(filteredHistory);

        // Filter Tab 1: สินค้าคงคลัง (จาก filteredOnHandAll)
        const filteredOnHand = (filteredOnHandAll || []).filter(
          (item) => item.WH_Id === parseInt(whId)
        );
        console.debug(" Setting formItemOnHandCaseTab:", filteredOnHand.length);
        setFormItemOnHandCaseTab(filteredOnHand);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  // SET ITEM
  const handleItemShow = async () => {
    const itemList = await getDataWithComp(
      "View_Set_Item",
      `AND ISNULL(is_Active, Item_Status) = 'Y'  ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line`
    );

    const itemHistory = await getDataWithComp(
      "API_1201_WH_ITEM_STC",
      `AND WH_Id = ${warehouseId} ORDER BY STC_SEQ DESC`
    );

    const itemHistoryIds = new Set(itemHistory.map((h) => h.Item_Id));

    const filteredItems = itemList.filter(
      (item) => !itemHistoryIds.has(item.Item_Id)
    );

    setFormItemList2(filteredItems);
    setShowItemModal(true);
  };

  const handleItemClose = () => setShowItemModal(false);
  const handleBeginWarehouse = async (itemsSelected) => {
    try {
      setShowItemModal(false);
      setIsLoading(true);

      if (warehouseId === null) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกคลัง");
      }

      const uniqueItems = Array.from(
        new Set(itemsSelected.map((item) => item.Item_Id))
      ).map((id) => itemsSelected.find((item) => item.Item_Id === id));

      await Promise.all(
        uniqueItems.map((item) =>
          manageWhItemData(
            item.Item_Id,
            item.Item_Code,
            item.Item_Name,
            parseCurrency(warehouseId),
            "BG",
            parseCurrency(item.inputQty || 0, 10),
            null,
            "เริ่มต้นคลัง",
            "เริ่มต้นคลัง",
            null
          )
        )
      );

      //  เก็บ index และ itemId ปัจจุบันไว้ก่อน
      const currentSelectedIndex = selectedIndex;
      const currentSelectedItemId = formItemList[selectedIndex]?.Item_Id;

      const itemList = await getDataWithComp(
        "View_Set_Item",
        `AND Item_Onhand > 0 AND ISNULL(is_Active, Item_Status) = 'Y' ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line`
      );

      const whList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY  WH_Name ASC`
      );
      if (whList && whList.length > 0) {
        setWhDataList(whList);
      }

      if (itemList && itemList.length > 0) {
        isManualSelectionRef.current = true;
        setAllItemsCache(itemList || []);
        shouldSelectFirstRowRef.current = false;
        currentItemIdRef.current = currentSelectedItemId;

        if (currentSelectedItemId) {
          const foundIndex = itemList.findIndex(
            (f) => f.Item_Id === currentSelectedItemId
          );

          if (foundIndex !== -1) {
            // เจอแถวเดิม -> กลับไปแถวเดิม
            currentItemIdRef.current = currentSelectedItemId;
            skipNextSelectEffectRef.current = true;
            setSelectedIndex(foundIndex);
            setItemId(currentSelectedItemId);
            localStorage.setItem("stc-item-id", currentSelectedItemId);
            localStorage.setItem("stc-item-wh", warehouseId);
            await onRowSelectOnHand(currentSelectedItemId, warehouseId);
          } else {
            // ไม่เจอแถวเดิม -> ไปแถวที่ใกล้ที่สุด
            const safeIndex = Math.min(
              currentSelectedIndex,
              itemList.length - 1
            );
            const newItem = itemList[safeIndex];
            currentItemIdRef.current = newItem.Item_Id;
            skipNextSelectEffectRef.current = true;
            setSelectedIndex(safeIndex);
            setItemId(newItem.Item_Id);

            localStorage.setItem("stc-item-id", newItem.Item_Id);
            localStorage.setItem("stc-item-wh", warehouseId);
            await onRowSelectOnHand(newItem.Item_Id, warehouseId);
          }
        }
        setTimeout(() => {
          isManualSelectionRef.current = false;
        }, 0);
      }

      getAlert("OK", "เริ่มต้นคลังสินค้าสำเร็จ");
      await handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleItemSearch = async (
    searchItemTerm,
    filterOption,
    preserve = false
  ) => {
    setFormItemList([]);
    const reqId = ++latestSearchRef.current;

    const statusFilter = showInactiveItems ? "" : "AND Item_Status = 'Y'";
    let query = `${statusFilter} `;
    if (searchItemTerm) {
      const normalizedSearch = searchItemTerm.trim().replace(/\s+/g, " ");
      query += `AND (REPLACE(REPLACE(REPLACE(Item_Code, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalizedSearch}%' 
            OR REPLACE(REPLACE(REPLACE(Item_Name, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalizedSearch}%' ) `;
    }
    if (filterOption === "0") query += "AND Reft_ItemOnhand > 0 ";
    if (filterOption === "1") query += "AND Reft_ItemOnhand >= 0 ";
    if (filterOption === "2") query += "AND Reft_ItemOnhand = 0 ";

    query +=
      "ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line";

    const itemList = await getDataWithComp("View_Set_Item", query);

    if (reqId === latestSearchRef.current) {
      const itemsToSet = itemList || [];

      if (preserve) {
        shouldSelectFirstRowRef.current = false;
      } else {
        shouldSelectFirstRowRef.current = true;
      }
      setFormItemList(itemsToSet);

      if (!itemsToSet?.length) {
        setSelectedIndex(-1);
        setItemId(null);
        currentItemIdRef.current = null;
      }
    }
  };

  const handleItemSearchFromDB = async (
    searchTerm,
    filterOption,
    preserve = true
  ) => {
    const reqId = ++latestSearchRef.current;

    const statusFilter = showInactiveItems ? "" : "AND Item_Status = 'Y'";
    let query = `${statusFilter} `;
    if (searchTerm) {
      const normalized = searchTerm.trim().replace(/\s+/g, " ");
      query += `AND (
      REPLACE(REPLACE(REPLACE(Item_Code, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalized}%'
      OR REPLACE(REPLACE(REPLACE(Item_Name, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalized}%'
    ) `;
    }

    if (filterOption === "0") query += "AND Reft_ItemOnhand > 0 ";
    if (filterOption === "1") query += "AND Reft_ItemOnhand >= 0 ";
    if (filterOption === "2") query += "AND Reft_ItemOnhand = 0 ";

    query +=
      "ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line";

    const itemList = await getDataWithComp("View_Set_Item", query);
    if (reqId !== latestSearchRef.current) return;

    const items = itemList || [];

    setAllItemsCache(items);
    if (preserve && itemId) {
      currentItemIdRef.current = itemId;
      shouldSelectFirstRowRef.current = false;
    } else if (!preserve) {
      // เมื่อ preserve=false ต้อง reset เพื่อให้เลือกแถวแรก
      currentItemIdRef.current = null;
      setSelectedIndex(-1);
      shouldSelectFirstRowRef.current = true;
    }

    filterLocalItems(searchTerm, filterOption, items);
  };

  const filterLocalItems = (searchTerm, filterOption, sourceList = null) => {
    const keyword = (searchTerm || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    let items = sourceList ? [...sourceList] : [...allItemsCache];

    if (filterOption === "0")
      items = items.filter((x) => Number(x.Item_Onhand) > 0);
    if (filterOption === "1")
      items = items.filter((x) => Number(x.Item_Onhand) >= 0);
    if (filterOption === "2")
      items = items.filter((x) => Number(x.Item_Onhand) === 0);

    //  ถ้าไม่พิมพ์อะไร ไม่ต้องไล่ includes 10,000 รอบ
    if (!keyword) {
      setFormItemList(items);
      return;
    }

    const kw = keyword;
    items = items.filter((x) => {
      const code = (x.Item_Code || "")
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();
      const name = (x.Item_Name || "")
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase();
      return code.includes(kw) || name.includes(kw);
    });

    setFormItemList(items);
  };

  const handleHistorySearch = async (year, month, itemId, warehouseId) => {
    let query = `AND Item_Id = ${itemId} AND WH_Id = ${warehouseId} `;

    let yearInAD = "";
    if (year) {
      yearInAD = (parseCurrency(year) - 543).toString();
    }

    if (yearInAD) {
      query += `AND YEAR(STC_Date) = ${yearInAD} `;
    }

    if (month) {
      query += `AND MONTH(STC_Date) = ${parseCurrency(month)} `;
    }

    query += `ORDER BY STC_SEQ DESC`;

    const itemHistory = await getDataWithComp("API_1201_WH_ITEM_STC", query);

    if (itemHistory && itemHistory.length > 0) {
      setFormItemHistory(itemHistory);
    } else {
      setFormItemHistory([]);
    }
  };

  const handleSubmit = async (payload) => {
    setIsLoading(true);
    const data = await submitItems(payload);
    if (data.ok) {
      setOpen(false);
      setIsLoading(false);
    } else {
      console.debug("submitItems failed:", data);
    }
  };

  const handleEditItem = async (item, index) => {
    try {
      // บันทึกตำแหน่งก่อนเปิด modal
      isManualSelectionRef.current = true;
      setSelectedIndex(index);
      
      console.debug("📝 Loading variants for:", item.Item_Short_Name);
      
      let details = [];
      try {
        // ดึง variants ทั้งหมดที่มี Item_Short_Name เดียวกัน
        const variantsQuery = `AND Item_Short_Name = '${item.Item_Short_Name}' AND Item_Status = 'Y' ORDER BY Item_Code`;
        const variants = await getDataWithComp("View_Set_Item", variantsQuery);
        
        if (variants && variants.length > 0) {
          console.debug("✅ Found", variants.length, "variants");
          details = variants.map((variant) => ({
            key: variant.Item_Code || String(variant.Item_Id),
            Item_Id: variant.Item_Id,
            Item_Barcode: variant.Item_Barcode ?? "",
            Item_Code: variant.Item_Code ?? "",
            Item_Name: variant.Item_Name ?? "",
            Item_Short_Name: variant.Item_Short_Name ?? "",
            Unit: variant.Item_Unit_IN ?? "",
            Colour: variant.Item_Colour ?? "",
            Size: variant.Item_Size ?? "",
            Brand: variant.Item_Brand ?? "",
            Series: variant.Item_Series ?? "",
            Cost: Number(variant.Item_Cost ?? 0),
            Price1: Number(variant.Item_Price ?? 0),
            Price2: Number(variant.Item_PriceA ?? 0),
            Price3: Number(variant.Item_PriceB ?? 0),
            StatusYN: variant.Item_Status ?? "Y",
          }));
        }
      } catch (err) {
        console.warn("Could not load variants, falling back to single item", err);
      }
      
      // Fallback ถ้าไม่เจอ variants หรือ error
      if (details.length === 0) {
        details = [
          {
            key: item.Item_Code || String(item.Item_Id),
            Item_Id: item.Item_Id,
            Item_Barcode: item.Item_Barcode ?? "",
            Item_Code: item.Item_Code ?? "",
            Item_Name: item.Item_Name ?? "",
            Item_Short_Name: item.Item_Short_Name ?? "",
            Unit: item.Item_Unit_IN ?? "",
            Colour: item.Item_Colour ?? "",
            Size: item.Item_Size ?? "",
            Brand: item.Item_Brand ?? "",
            Series: item.Item_Series ?? "",
            Cost: Number(item.Item_Cost ?? 0),
            Price1: Number(item.Item_Price ?? 0),
            Price2: Number(item.Item_PriceA ?? 0),
            Price3: Number(item.Item_PriceB ?? 0),
            StatusYN: item.Item_Status ?? "Y",
          },
        ];
      }
      
      // สร้างข้อมูลสำหรับ Modal (ใช้รูปแบบเดียวกับ TbSetItem)
      const initialData = {
        header: {
          Item_Group: item.Item_Group ?? "",
          Item_Short_Name: item.Item_Short_Name ?? "",
          Item_Name: item.Item_Name ?? "",
          Item_Name_EN: item.Item_Name_EN ?? "",
          Item_Unit_IN: item.Item_Unit_IN ?? "",
          Item_Brand: item.Item_Brand ?? "",
          Item_Series: item.Item_Series ?? "",
          Item_Cost: Number(item.Item_Cost ?? 0),
          Item_Price: Number(item.Item_Price ?? 0),
          Item_PriceA: Number(item.Item_PriceA ?? 0),
          Item_PriceB: Number(item.Item_PriceB ?? 0),
          Item_Status: item.Item_Status ?? "Y",
        },
        details: details,
      };

      console.debug("📦 Opening modal with", details.length, "variants");

      setEditModalState({
        open: true,
        mode: "edit",
        data: initialData,
      });
    } catch (error) {
      console.error("Error opening edit modal:", error);
      getAlert("FAILED", "ไม่สามารถเปิดหน้าแก้ไขได้");
    }
  };

  const handleEditModalClose = () => {
    console.debug("🔄 handleEditModalClose: Updating UI after edit");
    
    const keepItemId = itemId;
    const keepIndex = selectedIndex;
    
    // 🔒 บันทึก scroll position ทันที
    savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;
    console.debug("💾 Saved scroll position:", savedScrollTopRef.current);
    
    // ตั้ง flag เพื่อป้องกัน useEffect ทำงาน
    skipFilterRef.current = true;
    currentItemIdRef.current = keepItemId;
    shouldSelectFirstRowRef.current = false;
    
    // รอซักครู่ให้ database commit
    setTimeout(async () => {
      try {
        // ดึงข้อมูลใหม่จาก database
        let query = `AND Item_Status = 'Y' `;
        if (searchItemTerm) {
          const normalized = searchItemTerm.trim().replace(/\s+/g, " ");
          query += `AND (
            REPLACE(REPLACE(REPLACE(Item_Code, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalized}%'
            OR REPLACE(REPLACE(REPLACE(Item_Name, '  ', ' '), '  ', ' '), '  ', ' ') LIKE '%${normalized}%'
          ) `;
        }
        
        if (filterOption === "0") query += "AND Reft_ItemOnhand > 0 ";
        if (filterOption === "1") query += "AND Reft_ItemOnhand >= 0 ";
        if (filterOption === "2") query += "AND Reft_ItemOnhand = 0 ";
        
        query += "ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line";
        
        console.debug("🔍 Fetching fresh data from DB...");
        const freshItems = await getDataWithComp("View_Set_Item", query);
        console.debug("✅ Got", freshItems?.length, "fresh items");
        
        if (freshItems && freshItems.length > 0) {
          // อัพเดต cache
          setAllItemsCache([...freshItems]);
          
          // Filter items
          const keyword = (searchItemTerm || "").trim().replace(/\s+/g, " ").toLowerCase();
          let items = [...freshItems];
          
          if (filterOption === "0") items = items.filter((x) => Number(x.Item_Onhand) > 0);
          if (filterOption === "1") items = items.filter((x) => Number(x.Item_Onhand) >= 0);
          if (filterOption === "2") items = items.filter((x) => Number(x.Item_Onhand) === 0);
          
          if (keyword) {
            const kw = keyword;
            items = items.filter((x) => {
              const code = (x.Item_Code || "").trim().replace(/\s+/g, " ").toLowerCase();
              const name = (x.Item_Name || "").trim().replace(/\s+/g, " ").toLowerCase();
              return code.includes(kw) || name.includes(kw);
            });
          }
          
          console.debug("✅ Setting", items.length, "filtered items");
          setFormItemList([...items]);
          
          // รอให้ state update
          await new Promise((resolve) => setTimeout(resolve, 100));
          
          // 🎯 คงตำแหน่งเดิม
          if (keepItemId) {
            const newIndex = items.findIndex((item) => item.Item_Id === keepItemId);
            console.debug("🔍 Finding index for Item_Id", keepItemId, "→ found at", newIndex);
            if (newIndex !== -1) {
              setSelectedIndex(newIndex);
              setItemId(keepItemId);
              currentItemIdRef.current = keepItemId;
            }
          }
          
          // Force table re-render
          setTableRefreshKey((prev) => prev + 1);
          
          // เลือกแถวเดิม
          if (keepItemId && warehouseId) {
            await onRowSelectOnHand(keepItemId, warehouseId);
          }
        }
        
        // ปล่อย flag
        setTimeout(() => {
          skipFilterRef.current = false;
          shouldSelectFirstRowRef.current = true;
        }, 200);
        
        console.debug("✅ UI update complete");
      } catch (error) {
        console.error("❌ Error updating UI:", error);
        skipFilterRef.current = false;
        shouldSelectFirstRowRef.current = true;
      }
    }, 500);
  };

  const handleEditSubmit = async (payload) => {
   console.debug("🎯 handleEditSubmit CALLED with payload:", payload);
    try {
      setIsLoading(true);
      
      const data = await submitItems(payload);
     console.debug("📦 submitItems result:", data);
      
      if (data.ok) {
        // ปิด Modal
        setEditModalState({ open: false, mode: "edit", data: null });
        
        // บันทึก item ปัจจุบัน
        const keepItemId = itemId;
        const keepIndex = selectedIndex;
        
        console.debug("🔄 Updating item directly from payload", { keepItemId, keepIndex, payload });
        
        // ตั้ง flag เพื่อป้องกัน useEffect ทำงาน
        skipFilterRef.current = true;
        
        // อัพเดต cache ก่อน (ใช้ functional update)
        setAllItemsCache((prevCache) => {
          const updatedCache = prevCache.map((item) => {
            if (item.Item_Id === keepItemId) {
              const headerData = payload.header || {};
              return {
                ...item,
                Item_Price: Number(headerData.Item_Price ?? item.Item_Price),
                Item_PriceA: Number(headerData.Item_PriceA ?? item.Item_PriceA),
                Item_PriceB: Number(headerData.Item_PriceB ?? item.Item_PriceB),
                Item_Cost: Number(headerData.Item_Cost ?? item.Item_Cost),
                Item_Name: headerData.Item_Name || item.Item_Name,
                Item_Brand: headerData.Item_Brand || item.Item_Brand,
                Item_Series: headerData.Item_Series || item.Item_Series,
              };
            }
            return item;
          });
          
          console.debug("✅ Updated cache with", updatedCache.length, "items");
          return updatedCache;
        });
        
        // อัพเดต formItemList โดยตรง (ใช้ functional update)
        setFormItemList((prevList) => {
          const updatedItemList = prevList.map((item, index) => {
            if (index === keepIndex && item.Item_Id === keepItemId) {
              const headerData = payload.header || {};
              
              const updated = {
                ...item,
                Item_Price: Number(headerData.Item_Price ?? item.Item_Price),
                Item_PriceA: Number(headerData.Item_PriceA ?? item.Item_PriceA),
                Item_PriceB: Number(headerData.Item_PriceB ?? item.Item_PriceB),
                Item_Cost: Number(headerData.Item_Cost ?? item.Item_Cost),
                Item_Name: headerData.Item_Name || item.Item_Name,
                Item_Brand: headerData.Item_Brand || item.Item_Brand,
                Item_Series: headerData.Item_Series || item.Item_Series,
              };
              
              console.debug("✅ Updated item in list:", updated);
              return updated;
            }
            return item;
          });
          
          return updatedItemList;
        });

        
        // บันทึก scroll position
        savedScrollTopRef.current = allItemsScrollRef.current?.scrollTop || 0;
        currentItemIdRef.current = keepItemId;
        shouldSelectFirstRowRef.current = false;
        
        // เลือกแถวเดิม
        if (keepItemId && warehouseId) {
          await onRowSelectOnHand(keepItemId, warehouseId);
        }
        
        // Force table re-render โดย update key
        setTableRefreshKey((prev) => prev + 1);
        
        // ปล่อย flag หลัง render เสร็จ
        setTimeout(() => {
          skipFilterRef.current = false;
        }, 100);
        
        getAlert("OK", "แก้ไขสินค้าสำเร็จ");
      } else {
        console.error("submitItems failed:", data);
        getAlert("FAILED", "แก้ไขสินค้าไม่สำเร็จ");
      }
    } catch (error) {
      console.error("Error submitting edit:", error);
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการแก้ไข");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // ถ้ากำลังแก้ไขสินค้า ห้าม filter ทับ
    if (skipFilterRef.current) {
      console.debug("⏭️ Skipping filter during edit");
      return;
    }
    filterLocalItems(searchItemTerm, filterOption);
  }, [filterOption, allItemsCache]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (formItemList.length === 0) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        //  เพิ่มบรรทัดนี้
        isManualSelectionRef.current = true;
        setSelectedIndex((prev) =>
          prev < formItemList.length - 1 ? prev + 1 : prev
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        //  เพิ่มบรรทัดนี้
        isManualSelectionRef.current = true;
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [formItemList]);

  useEffect(() => {
    if (restoringScrollRef.current) return;
    if (selectedIndex >= 0 && rowRefs.current[selectedIndex]) {
      rowRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemIdRef.current = itemId;
  }, [itemId]);

  useEffect(() => {
    if (selectedIndex >= 0 && selectedIndex < formItemList.length) {
      const selectedItem = formItemList[selectedIndex];
      if (skipNextSelectEffectRef.current) {
        skipNextSelectEffectRef.current = false;
        return;
      }

      //  ล้าง debounce เก่า
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      //  ตั้ง debounce ใหม่
      debounceRef.current = setTimeout(() => {
        const nextId = selectedItem.Item_Id;
        if (
          currentItemIdRef.current === nextId &&
          itemIdRef.current === nextId
        ) {
          isManualSelectionRef.current = false;
          return;
        }
        currentItemIdRef.current = selectedItem.Item_Id;
        setItemId(selectedItem.Item_Id);
        onRowSelectOnHand(selectedItem.Item_Id, warehouseId);
        localStorage.setItem("stc-item-id", selectedItem.Item_Id);
        localStorage.setItem("stc-item-wh", warehouseId);

        //  Reset flag หลังจากทำงานเสร็จ
        isManualSelectionRef.current = false;
      }, 100);

      return () => {
        if (debounceRef.current) {
          clearTimeout(debounceRef.current);
        }
      };
    }
  }, [selectedIndex, warehouseId]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsFormItemHistoryLoaded(!formItemHistory[0]);
    }, 300);

    return () => clearTimeout(timeout);
  }, [formItemHistory]);

  useEffect(() => {
    const keyword = searchItemOnHandCaseTab
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

    const filtered = formItemOnHandCaseTab.filter((item) => {
      const itemCode =
        item.Item_Code?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      const itemName =
        item.Item_Name?.trim().replace(/\s+/g, " ").toLowerCase() || "";
      return itemCode.includes(keyword) || itemName.includes(keyword);
    });

    setFilteredItems(filtered);
  }, [searchItemOnHandCaseTab, formItemOnHandCaseTab]);

  useEffect(() => {
    rowRefs.current = [];
  }, [formItemList]);

  useEffect(() => {
    if (isManualSelectionRef.current) return;

    if (!warehouseId) return;
    if (formItemList.length === 0) return;

    if (!shouldSelectFirstRowRef.current) {
      // ถ้าห้ามเลือกแถวแรก → พยายามคงแถวเดิม
      if (currentItemIdRef.current) {
        const index = formItemList.findIndex(
          (item) => item.Item_Id === currentItemIdRef.current
        );
        if (index !== -1) {
          if (selectedIndex !== index) {
            setSelectedIndex(index);
          }

          shouldSelectFirstRowRef.current = true;
          return;
        }
      }
      shouldSelectFirstRowRef.current = true;
    }

    if (selectedIndex === -1 && !currentItemIdRef.current) {
      const firstItem = formItemList[0];
      setSelectedIndex(0);
      setItemId(firstItem.Item_Id);
      currentItemIdRef.current = firstItem.Item_Id;
      onRowSelectOnHand(firstItem.Item_Id, warehouseId);
      localStorage.setItem("stc-item-id", firstItem.Item_Id);
      localStorage.setItem("stc-item-wh", warehouseId);
    }
  }, [formItemList]);

  useEffect(() => {
    const el = allItemsScrollRef.current;
    if (!el) return;

    // กันชน: ระหว่างคืนสกอลล์ อย่าให้ scrollIntoView มาดึงไปแถว
    restoringScrollRef.current = true;

    requestAnimationFrame(() => {
      el.scrollTop = savedScrollTopRef.current || 0;

      // ปล่อยกันชนหลังคืนค่าเสร็จ
      requestAnimationFrame(() => {
        restoringScrollRef.current = false;
      });
    });
  }, [formItemList]);

  return (
    <>
      <Breadcrumbs
        page={"คลังสินค้า"}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: name, url: "/warehouse-stock" },
          { name: "สร้าง" + name, url: "#" },
        ]}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div style={{ maxHeight: "90vh", overflowY: "auto" }}>
        <div className="container-fluid my-2">
          <div className="row">
            <div className="col-4">
              <div className="d-flex align-items-center">
                <h5 className="text-nowrap card-title mb-0 me-3">
                  ค้นหาสินค้า
                </h5>
                <div className="position-relative w-100">
                  <input
                    type="text"
                    className="form-control pe-5"
                    value={searchItemTerm}
                    onChange={(e) => {
                      const v = e.target.value;
                      setSearchItemTerm(v);
                      localStorage.setItem("stc-item-search", v);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        // เคลียร์ debounce ที่ค้างอยู่ (ถ้ามี)
                        if (searchDebounceRef.current)
                          clearTimeout(searchDebounceRef.current);
                        
                        const v = e.currentTarget.value;
                        handleItemSearchFromDB(v, filterOption, false);
                      }
                    }}
                  />

                  {searchItemTerm?.trim() && (
                    <button
                      type="button"
                      className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2"
                      style={{ borderRadius: 999 }}
                      onClick={() => {
                        // เคลียร์ค่า + เคลียร์ debounce ที่ค้าง
                        if (searchDebounceRef.current)
                          clearTimeout(searchDebounceRef.current);

                        setSearchItemTerm("");
                        localStorage.setItem("stc-item-search", "");

                        // รีเฟรชข้อมูลจาก database และเลือกแถวแรก
                        handleItemSearchFromDB("", filterOption, false);
                      }}
                      aria-label="clear search"
                      title="ล้างคำค้นหา"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-8">
              <div className="d-flex">
               
                <select
                  className="form-select"
                  style={{ maxWidth: "190px" }}
                  value={filterOption}
                  onChange={(e) => {
                    setFilterOption(e.target.value);
                    localStorage.setItem("stc-item-option", e.target.value);
                  }}
                >
                  <option value="0">แสดงยอดคงเหลือ &#62; 0</option>
                  <option value="1">แสดงยอดคงเหลือ &#62; = 0</option>
                  <option value="2">แสดงยอดคงเหลือ = 0</option>
                  <option value="3">แสดงทุกรายการ</option>
                </select>
                 <label style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: 15 }}>
                  <input
                    type="checkbox"
                    checked={showInactiveItems}
                    onChange={(e) => setShowInactiveItems(e.target.checked)}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{width:"560px"}}>แสดงสินค้ารายการเก่า</span>
                </label>
                <button
                  type="button"
                  className="btn btn-primary mx-2"
                  onClick={() =>
                    handleItemSearchFromDB(searchItemTerm, filterOption, false)
                  }
                  style={{ minWidth: "80px" }}
                >
                  <i className="fa fa-search me-1" aria-hidden="true"></i>
                  ค้นหา
                </button>
                <button
                  className="btn text-white mx-4"
                  style={{ backgroundColor: "rgb(239, 108, 0)" }}
                  onClick={() => ExportInventories(formItemOnHand)}
                >
                  <i className="fa fa-file-excel me-1" aria-hidden="true"></i>{" "}
                  Export สินค้ายอดคงเหลือ
                </button>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "rgb(239, 108, 0)" }}
                  onClick={() =>
                    ExportInventoriesWarehouse(formItemOnHandCaseTab)
                  }
                >
                  <i className="fa fa-warehouse me-1" aria-hidden="true"></i>{" "}
                  Export สินค้าแยกตามคลัง
                </button>
              </div>
            </div>
            <div className="col-2" />
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-8">
            <div className="col-12">
              <div className="card">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1px auto auto",
                    alignItems: "self-end",
                    justifyContent: "space-between",
                  }}
                >
                  <div></div>
                  <div>
                    <h5 className="card-title mt-3 me-4 text-center">
                      สินค้าทั้งหมด
                    </h5>
                  </div>
                  <div>
                    <Button
                      type="primary"
                      onClick={() => setOpen(true)}
                      style={{
                        marginRight: 10,
                        backgroundColor: " rgb(239, 108, 0)",
                      }}
                    >
                      สร้าง รายการสินค้า
                    </Button>
                    <ProductModal
                      open={open}
                      setOpen={setOpen}
                      onClose={() => setOpen(false)}
                      onSubmit={handleSubmit}
                      mode="create"
                      initialData={null}
                    />
                  </div>
                </div>

                <div className="card-body">
                  <div
                    ref={allItemsScrollRef}
                    className="table-responsive"
                    style={{
                      maxHeight: "350px",
                      overflowY: "auto",
                      marginTop: "5px",
                    }}
                  >
                    <table
                      id="tbl-all-items"
                      key={`items-table-${tableRefreshKey}`}
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "1%" }}>
                            #
                          </th>
                          <th
                            className="text-center"
                            style={{ maxwidth: "100px" }}
                          >
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "38%" }}>
                            ชื่อสินค้า
                          </th>
                          <th className="text-center" style={{ width: "8%" }}>
                            คงเหลือ
                          </th>
                          <th className="text-center" style={{ width: "5%" }}>
                            หน่วย
                          </th>
                          <th className="text-center" style={{ width: "5%" }}>
                            ตั้งต้น
                          </th>
                          <th className="text-center">กลุ่มสินค้า</th>
                          <th className="text-center">ราคา1</th>
                          <th className="text-center">ราคา2</th>
                          <th className="text-center">ราคา3</th>
                          <th className="text-center" style={{ width: "5%" }}>
                            แก้ไข
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formItemList.length > 0 ? (
                          formItemList.map((item, index) => (
                            <tr
                              key={item.Item_Id}
                              ref={(el) => (rowRefs.current[index] = el)}
                              onClick={() => {
                                isManualSelectionRef.current = true;
                                currentItemIdRef.current = item.Item_Id;
                                setSelectedIndex(index);
                              }}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  selectedIndex === index
                                    ? "rgb(105, 188, 216)"
                                    : "transparent",
                                transition: "background-color 0.3s ease",
                              }}
                            >
                              <td className="text-center">{index + 1}</td>
                              <td
                                className="text-center"
                                style={{ maxwidth: "100px" }}
                              >
                                {item.Item_Code}
                              </td>
                              <td className="text-left">{item.Item_Name}</td>
                              <td className="text-end">
                                {formatCurrency(item.Item_Onhand)}
                              </td>
                              <td className="text-center">
                                {item.Item_Unit_IN}
                              </td>
                              <td className="text-center">
                                {!hasInitialStockInWarehouse(
                                  item.Item_Id,
                                  warehouseId
                                ) ? (
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleInitialStockShow(item, index);
                                    }}
                                    title="ตั้งต้นสินค้า"
                                  >
                                    <i
                                      className="fa fa-plus-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                ) : (
                                  // <span className="text-success">
                                  //   <i
                                  //     className="fa fa-check-circle"
                                  //     aria-hidden="true"
                                  //   ></i>
                                  // </span>
                                  <></>
                                )}
                              </td>

                              <td className="">{item.Group_Name}</td>
                              <td className="text-end">
                                {formatCurrency(item.Item_Price)}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_PriceA)}
                              </td>
                              <td className="text-end">
                                {formatCurrency(item.Item_PriceB)}
                              </td>
                              <td className="text-center">
                                <i
                                  className="fas fa-edit fw-bold"
                                  style={{ color: "#EF6C00", cursor: "pointer" }}
                                  title="แก้ไขสินค้า"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditItem(item, index);
                                  }}
                                ></i>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={11}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  จำนวน: {formItemList.length.toLocaleString()} รายการ
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="col-12">
              <div className="card">
                {/* <h5 className="card-title mt-3 me-4 text-center">
                  สินค้าคงเหลือแยกตามคลัง
                </h5> */}
                <div className="card-body">
                  <div className="table-responsive">
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        margin: "0px 0px",
                      }}
                    >
                      {formItemOnHand?.at(0)?.Item_Code
                        ? `${formItemOnHand?.at(0)?.Item_Code}`
                        : ""}
                    </p>
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        margin: "-4px 0px",
                      }}
                    >
                      {formItemOnHand?.at(0)?.Item_Name
                        ? `${formItemOnHand?.at(0)?.Item_Name}`
                        : ""}
                    </p>
                    <table
                      id="tbl-onhand"
                      className="table table-striped table-hover"
                    >
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-center" style={{ width: "3%" }}>
                            #
                          </th>
                          {/* <th className="text-center" style={{ width: "15%" }}>
                            รหัสสินค้า
                          </th>
                          <th className="text-center" style={{ width: "30%" }}>
                            ชื่อสินค้า
                          </th> */}
                          <th className="text-center" style={{ width: "25%" }}>
                            คลังสินค้า
                          </th>
                          <th className="text-center" style={{ width: "10%" }}>
                            คงเหลือ
                          </th>

                          <th className="text-center" style={{ width: "20%" }}>
                            วันที่ล่าสุด
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formItemOnHand.length > 0 ? (
                          formItemOnHand.map((item, index) => (
                            <tr key={item.Item_Id || index + 1}>
                              <td className="text-center">{index + 1}</td>
                              {/* <td className="text-center">{item.Item_Code}</td>
                              <td className="text-left">{item.Item_Name}</td> */}
                              <td className="text-center">{item.WH_Name}</td>

                              <td className="text-end">
                                {formatCurrency(item.Item_Onhand)}
                              </td>
                              <td className="text-center">
                                {item.Last_STC_Date
                                  ? formatDateAndTime(item.Last_STC_Date)
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6}>
                              <center>
                                <h5>ไม่พบข้อมูล</h5>
                              </center>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  จำนวน: {formItemOnHand.length.toLocaleString()} รายการ
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(1);
                        localStorage.setItem("stc-active-tab", 1);
                      }}
                    >
                      สินค้าคงเหลือแยกตามคลัง
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      style={{ cursor: "pointer", color: "#EF6C00" }}
                      className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                      onClick={() => {
                        setActiveTab(2);
                        localStorage.setItem("stc-active-tab", 2);
                      }}
                    >
                      ประวัติสินค้าเคลื่อนไหว
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content mt-3">
                <div
                  className={`tab-pane fade ${
                    activeTab === 1 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <div className=" d-flex">
                          <h4 className="card-title mb-0 me-2">เลือกคลัง</h4>
                          <select
                            style={{ width: "200px" }}
                            className="form-select"
                            value={warehouseId || ""}
                            onChange={(e) => {
                              onChangeWarehouse(e.target.value);
                              localStorage.setItem(
                                "stc-select-warehouse",
                                e.target.value
                              );
                            }}
                          >
                            <option value={""}>กรุณาเลือกคลัง</option>
                            {whDataList.map((ware) => (
                              <option key={ware.WH_Id} value={ware.WH_Id}>
                                {ware.WH_Name}
                              </option>
                            ))}
                          </select>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginLeft: "10px" }}
                          >
                            <h5 className="text-nowrap card-title mb-0 me-3">
                              ค้นหาสินค้า
                            </h5>
                            <input
                              type="text"
                              className="form-control"
                              style={{ width: "400px" }}
                              value={searchItemOnHandCaseTab}
                              onChange={(e) => {
                                setSearchItemOnHandCaseTab(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="tbl-history"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "3%" }}
                                >
                                  #
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "60%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "6%" }}
                                >
                                  คงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "12%" }}
                                >
                                  วันที่ทำรายการล่าสุด
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredItems.length > 0 ? (
                                filteredItems.map((item, index) => (
                                  <tr key={item.Item_Id || index + 1}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                      {item.Item_Code}
                                    </td>
                                    <td className="text-left">
                                      {item.Item_Name}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(item.Item_Onhand)}
                                    </td>
                                    <td className="text-center">
                                      {item.WH_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Last_STC_Date
                                        ? formatDateAndTime(item.Last_STC_Date)
                                        : ""}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={10}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        จำนวน: {filteredItems.length.toLocaleString()} รายการ
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    activeTab === 2 ? "show active" : ""
                  }`}
                  role="tabpanel"
                >
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="container-fluid">
                          <div
                            className="d-flex flex-row"
                            style={{
                              display: "grid",
                              gridTemplateColumns: "auto auto",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="col-3 d-flex">
                              <h4 className="card-title mb-0 me-2">
                                เลือกคลัง
                              </h4>
                              <select
                                style={{ width: "200px" }}
                                className="form-select"
                                value={warehouseId || ""}
                                onChange={(e) => {
                                  onChangeWarehouse(e.target.value);
                                  localStorage.setItem(
                                    "stc-select-warehouse",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value={""}>กรุณาเลือกคลัง</option>
                                {whDataList.map((ware) => (
                                  <option key={ware.WH_Id} value={ware.WH_Id}>
                                    {ware.WH_Name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="mx-2">
                              <div className="d-flex">
                                {isFormItemHistoryLoaded &&
                                  !formItemHistory[0] && (
                                    <button
                                      className="btn text-white btn-lg"
                                      onClick={handleItemShow}
                                      style={{
                                        backgroundColor: "rgb(239, 108, 0)",
                                        marginRight: "10px",
                                      }}
                                      disabled={
                                        warehouse_Id === "3" &&
                                        Emp_Position !== "1"
                                      }
                                    >
                                      <i
                                        className="fa fa-plus me-1"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      ตั้งต้นสินค้า
                                    </button>
                                  )}
                                {formItemHistory[0] && (
                                  <button
                                    className="btn text-white btn-lg"
                                    onClick={handleWhShow}
                                    style={{
                                      backgroundColor: "rgb(239, 108, 0)",
                                    }}
                                    disabled={
                                      warehouse_Id === "3" &&
                                      Emp_Position !== "1"
                                    }
                                  >
                                    <i
                                      className="fa fa-edit me-1"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    ปรับปรุงคลัง
                                  </button>
                                )}

                                <ItemModal
                                  formDetailList={[]}
                                  showItemModal={showItemModal}
                                  handleItemClose={handleItemClose}
                                  itemDataList={formItemList2}
                                  onRowSelectItem={handleBeginWarehouse}
                                />
                                <AdjustWhModal
                                  whDataList={whDataList}
                                  showWhModal={showWhModal}
                                  handleWhClose={handleWhClose}
                                  handleADJClose={handleADJClose}
                                  itemDetailModal={formItemHistory[0]}
                                  warehouseId={warehouseId}
                                  selectedItem={formItemList[selectedIndex]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table
                            id="basic-datatables"
                            className="table table-striped table-hover"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "4%" }}
                                >
                                  #
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  รหัสสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "23%" }}
                                >
                                  ชื่อสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "5%" }}
                                >
                                  ประเภท
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  จำนวน
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "7%" }}
                                >
                                  จำนวนคงเหลือ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  วันที่ทำรายการ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  ผู้ทำรายการ
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  คลังสินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "8%" }}
                                >
                                  เลขเอกสาร
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  เอกสารอ้างอิง
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "10%" }}
                                >
                                  หมายเหตุ
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {formItemHistory.length > 0 ? (
                                formItemHistory.map((item, index) => (
                                  <tr key={item.STC_Id}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                      {item.Item_Code}
                                    </td>
                                    <td className="text-left">
                                      {item.Item_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_Type}
                                    </td>
                                    <td className="text-end">
                                      {item.Doc_Type === "TO" ||
                                      item.Doc_Type === "AO" ||
                                      item.Doc_Type === "OUT"
                                        ? "-"
                                        : ""}
                                      {formatCurrency(item.STC_QTY)}
                                    </td>
                                    <td className="text-end">
                                      {formatCurrency(item.STC_Balance)}
                                    </td>
                                    <td className="text-center">
                                      {formatDateAndTime(item.STC_Date)}
                                    </td>
                                    <td className="text-center">
                                      {item.Emp_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.WH_Name}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_No}
                                    </td>
                                    <td className="text-center">
                                      {item.Doc_NoRef &&
                                        item.Doc_NoRef.split("ยกเลิก").map(
                                          (part, index, array) => (
                                            <React.Fragment key={index}>
                                              {part}
                                              {index < array.length - 1 && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  <strong>ยกเลิก</strong>
                                                </span>
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </td>
                                    <td className="text-center">
                                      {item.STC_Remark || "-"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={12}>
                                    <center>
                                      <h5>ไม่พบข้อมูล</h5>
                                    </center>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        จำนวน: {formItemHistory.length.toLocaleString()} รายการ
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Modal ตั้งต้นสินค้ารายตัว */}
          {showInitialStockModal && selectedItemForInitial && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={handleInitialStockClose}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div
                    className="modal-header"
                    style={{ backgroundColor: "#EF6C00", color: "white" }}
                  >
                    <h5 className="modal-title">
                      <i
                        className="fa fa-plus-circle me-2"
                        aria-hidden="true"
                      ></i>
                      ตั้งต้นสินค้า
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={handleInitialStockClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div
                      className="card mb-3"
                      style={{ backgroundColor: "#f8f9fa" }}
                    >
                      <div className="card-body">
                        <h6 className="card-subtitle mb-2 text-muted">
                          ข้อมูลสินค้า
                        </h6>
                        <p className="mb-1">
                          <strong>รหัสสินค้า:</strong>{" "}
                          {selectedItemForInitial.Item_Code}
                        </p>
                        <p className="mb-0">
                          <strong>ชื่อสินค้า:</strong>{" "}
                          {selectedItemForInitial.Item_Name}
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          <strong>คลังสินค้า</strong>
                        </label>
                        <select
                          className="form-select"
                          value={warehouseId || ""}
                          disabled
                        >
                          <option value="">กรุณาเลือกคลัง</option>
                          {whDataList.map((wh) => (
                            <option key={wh.WH_Id} value={wh.WH_Id}>
                              {wh.WH_Name}
                            </option>
                          ))}
                        </select>
                        {!warehouseId && (
                          <small className="text-danger">
                            กรุณาเลือกคลังจาก dropdown ด้านบน
                          </small>
                        )}
                      </div>

                      <div className="col-12">
                        <label className="form-label">
                          <strong>จำนวนเริ่มต้น</strong>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ระบุจำนวน"
                          value={initialQuantity}
                          onChange={(e) => {
                            const value = e.target.value.replace(/,/g, "");
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              setInitialQuantity(
                                value
                                  ? formatterWithCommas(parseFloat(value))
                                  : ""
                              );
                            }
                          }}
                          onFocus={selectOnFocus}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              document
                                .getElementById("submit-initial-stock-btn")
                                ?.click();
                              return;
                            }
                            onlyNumberKeyDown(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleInitialStockClose}
                    >
                      <i className="fa fa-times me-1" aria-hidden="true"></i>
                      ยกเลิก
                    </button>
                    <button
                      id="submit-initial-stock-btn"
                      type="button"
                      className="btn text-white"
                      style={{ backgroundColor: "#EF6C00" }}
                      onClick={() => {
                        if (!warehouseId) {
                          getAlert("FAILED", "กรุณาเลือกคลังก่อน");
                          return;
                        }
                        const qty = parseFloat(parserStrict(initialQuantity));
                        if (!qty || qty <= 0) {
                          getAlert("FAILED", "กรุณาใส่จำนวนที่ถูกต้อง");
                          return;
                        }
                        handleInitialStockSubmit({
                          itemId: selectedItemForInitial.Item_Id,
                          itemCode: selectedItemForInitial.Item_Code,
                          itemName: selectedItemForInitial.Item_Name,
                          warehouseId: warehouseId,
                          quantity: qty,
                        });
                      }}
                    >
                      <i className="fa fa-check me-1" aria-hidden="true"></i>
                      ตกลง
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal สำหรับแก้ไขสินค้า */}
          <ProductModal
            open={editModalState.open}
            setOpen={(open) => {
              console.debug("📢 ProductModal setOpen called:", open);
              // ถ้าปิด modal (open = false) → รีเฟรชข้อมูล
              if (!open && editModalState.open) {
                console.debug("🔄 Modal closing, refreshing data...");
                handleEditModalClose();
              }
              setEditModalState((prev) => ({ ...prev, open }));
            }}
            mode={editModalState.mode}
            initialData={editModalState.data}
            onClose={() => {
              console.debug("🚪 ProductModal onClose called");
              handleEditModalClose();
              setEditModalState({ open: false, mode: "edit", data: null });
            }}
            onDataChanged={(data) => {
              console.debug("💾 ProductModal onDataChanged called:", data);
              // ProductModal บันทึกข้อมูลเองแล้ว เราแค่รีเฟรช UI
              handleEditModalClose();
            }}
          />
        </div>
      </div>

      <style jsx global>{`
        .items-table .ant-table-content,
        .items-table .ant-table-body {
          overflow: auto !important;
          scrollbar-gutter: stable both-edges;
          scrollbar-width: thin;
        }
        .items-table .ant-table-content::-webkit-scrollbar,
        .items-table .ant-table-body::-webkit-scrollbar {
          height: 10px;
          width: 10px;
        }
        .items-table .ant-table-content::-webkit-scrollbar-thumb,
        .items-table .ant-table-body::-webkit-scrollbar-thumb {
          background: rgba(0, 0, 0, 0.3);
          border-radius: 8px;
        }
        .ant-table-wrapper .ant-table-thead > tr > th {
          background: #d05c00 !important;
          color: #fff;
          font-weight: 600;
        }
        .ant-table-tbody > tr.row-even > td {
          background: #ffffff;
        }
        .ant-table-tbody > tr.row-odd > td {
          background: oklch(0.98 0.01 71.17);
        }
        .ant-table-tbody > tr:hover > td {
          background: oklch(0.91 0.05 60.5) !important;
        }
        .ant-table-tbody > tr.ant-table-row-selected > td {
          background: oklch(0.91 0.05 60.5) !important;
        }
      `}</style>
    </>
  );
}

export default Form;
